import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@lib/components/base';
import { AppAssets } from './app.assests';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TenantConfigurationService } from '@lib/services';
import { TenantService } from '@lib/services/tenant.service';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.state';
import { selectEncryptedTenantKey } from '@store/selectors/tenant.selectors';
import { setTenantKey } from '@store/actions/tenant.actions';
import { setPermissions } from '@store/actions/permission.actions';
import { take } from 'rxjs';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { Location } from '@angular/common';
import { applyTenantTheme } from '@lib/constants/tenant.constant';

interface CustomJwtPayload extends JwtPayload {
    tenant?: string;
}

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseComponent implements OnInit {
    tenantKey: string;
    dataReady = false;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    constructor(
        appAssets: AppAssets,
        private tenantConfigurationService: TenantConfigurationService,
        private store: Store<AppState>,
        private location: Location
    ) {
        super();
    }

    ngOnInit(): void {        
        const API_SUFFIX = '_api';
        const token = localStorage.getItem('accessToken'); 
        if (token) {
            try {
                const decodedToken = jwtDecode<CustomJwtPayload>(token);
                if (decodedToken) {
                    const tenantKey = decodedToken.tenant + API_SUFFIX;
                    this.store.dispatch(setTenantKey({ tenantKey }));
                    const permissionIds = JSON.parse(localStorage.getItem('permissions') || '[]');
                    this.store.dispatch(setPermissions({ permissions: permissionIds }));
                    this.addSubscription(
                        this.store
                            .select(selectEncryptedTenantKey)
                            .pipe(take(1))
                            .subscribe(() => {
                                this.dataReady = true;
                            }),
                    );
                } else {
                    this.dataReady = true; // Ensure dataReady is set even tenant_id is missing
                }
            } catch {
                this.dataReady = true; // Ensure dataReady is set even on error
            }
        } else {
            this.dataReady = true; // Ensure dataReady is set if token is missing
        }

        this.addSubscription(
            this.store.select(selectEncryptedTenantKey).subscribe((key: string | null) => {
                if (key) {
                    this.tenantKey = new TenantService(this.store).getTenantKey() || '';
                    this.tenantConfigurationService.setFavicon(this.tenantKey);
                    applyTenantTheme(this.tenantKey);
                }
            }),
        );
    }
}
